import { deriveCurrencyFormat } from '../../../../../../../i18n/currencies';
import type { Languages } from '../../../../../../../i18n/i18n.language-config';
import type { Nullable } from '../../../../../../../types/common/utility';

/**
 * Legacy quote-underwriting sessions (outside the MTE/coverage-endorsements
 * flow) have no currency source at all — `RatingDetails` carries none. This
 * reproduces the locale-derived formatting `DeltaPricing` used before it grew
 * a `currency` prop, so that domain still renders a real amount instead of the
 * `CurrencyAmount` placeholder.
 *
 * Deliberately kept out of `DeltaPricing.tsx`: that file is on the
 * `no-restricted-imports` guard (MS-266/MS-406, see apps/console/.eslintrc.js)
 * banning `deriveCurrencyFormat` imports, since it renders via `CurrencyAmount`
 * whenever a currency is available. This module is the single carved-out
 * exception for the currency-less fallback, not a way around the guard.
 */
export const formatLegacyDeltaPrice = (
  language: Languages,
  price: Nullable<number>,
  isNegative: boolean
) => {
  const formattedPrice = deriveCurrencyFormat(language, Math.abs(price ?? 0));
  return isNegative ? `(${formattedPrice})` : formattedPrice;
};
